<template>
  <div
    class="question-container"
    :style="{
      border:
        dataObj.status === 1
          ? '1px dashed rgba(58,96,255,1)'
          : '1px solid #dcdde0',
    }"
  >
    <div class="question-type">问答</div>
    <div class="title-view">
      <span style="color: #4c4a56">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span
        >{{ `${index + 1}、` }}
        <span style="color: #4c4a56">
          {{ `${dataObj.caseProblem}` }}
          <span
            style="
              position: relative;
              top: -2px;
              padding: 0 8px;
              line-height: 20px;
              background: rgba(58, 96, 255, 0.09);
              border: 1px solid rgba(58, 96, 255, 0.4);
              border-radius: 4px;
              font-size: 13px;
              font-weight: 500;
              text-align: center;
              color: #3a60ff;
              display: inline-block;
              margin-left: 10px;
            "
          >
            {{ dataObj.questionScore ? dataObj.questionScore : "0" }}分
          </span>
        </span>
      </span>
    </div>
    <div class="question-images">
      <div
        v-for="(item, idx) in images"
        :key="idx"
        style="margin-top: 20px; position: relative"
      >
        <img :src="item" style="width: 100%" />
      </div>
    </div>
    <div
      :style="{ border: isFocus ? `1px solid ${color}` : '1px solid #EDEDED' }"
      class="textarea-view"
    >
      <el-input
        v-if="dataObj.status === 3 || dataObj.status === 4"
        type="textarea"
        v-model="context"
        placeholder="请输入"
        :autosize="{ minRows: 3 }"
        @focus="isFocus = true"
        @blur="handleTextareaBlur()"
        @input="handleInputChange"
        :disabled="dataObj.status !== 4 || showState === 10"
      ></el-input>
      <span v-else class="textarea-placeholder">请输入</span>
    </div>
    <div v-if="showState === 10 || showState === 7">
      <div
        v-if="dataObj.ifRight"
        style="display: flex; align-items: center; margin-top: 20px"
      >
        <img
          src="https://ossfastmake.mustke.com/qrCode/tupian/1748335507420.svg"
          style="width: 16px; height: 16px"
        />
        <span class="correct-text">回答正确 +{{ dataObj.score }}分</span>
      </div>
      <div v-else style="display: flex; align-items: center; margin-top: 20px">
        <img
          src="https://ossfastmake.mustke.com/qrCode/tupian/1748335577224.svg"
          style="width: 16px; height: 16px"
        />
        <span class="error-text" style="font-size: 15px; font-weight: 500"
          >答错了 {{ dataObj.score > 0 ? `+${dataObj.score}分` : "" }}</span
        >
      </div>
      <div
        v-if="!dataObj.ifRight && dataObj.scoringMethod === 0"
        style="margin-top: 10px"
      >
        <span
          style="
            font-size: 15px;
            font-weight: 500;
            text-align: left;
            color: #00c755;
          "
          >正确答案</span
        >
        <div
          style="
            word-break: break-all;
            width: 100%;
            padding: 13px;
            box-sizing: border-box;
            background: #f7f7f7;
            border: 1px solid #ededed;
            border-radius: 3px;
            margin-top: 8px;
          "
        >
          {{ dataObj.chooseAnswer }}
        </div>
      </div>
      <div
        v-if="dataObj.scoringMethod !== 0"
        class="explanation-section"
        style="margin-top: 13px"
      >
        <span class="section-title">关键词</span>
        <div class="textarea-view">{{ dataObj.keyword || "暂无内容" }}</div>
      </div>
      <div class="explanation-section" style="margin-top: 10px">
        <span class="section-title" style="font-size: 15px; font-weight: 500"
          >答案解析</span
        >
        <div class="textarea-view">{{ dataObj.analysis || "暂无内容" }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExamPreviewQA",
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      context: "",
      isFocus: false,
      color: "#3A60FF",
      images: [],
      index: 0,
      showState: 0,
    };
  },
  watch: {
    params: {
      handler(newValue) {
        if (newValue && newValue.data) {
          this.dataObj = newValue.data;
          this.index = newValue.index;
          this.showState = newValue.state;
          this.images = JSON.parse(newValue.data.caseProblemImg || "[]");
          this.context = newValue.data.context;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleTextareaBlur() {
      this.isFocus = false;
    },
    handleInputChange() {
      const updatedData = {
        ...this.dataObj.data,
        context: this.context,
      };

      const answerObj = {
        question_id: this.dataObj.data.id,
        type: this.dataObj.data.type,
        if_hide: this.dataObj.data.if_hide,
        answer: [{ id: "", context: this.context }],
      };

      this.$emit(
        "update",
        JSON.stringify({
          data: updatedData,
          answer: answerObj,
          index: this.index,
        }),
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./exam-preview-common.scss";

.textarea-view {
  height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/ExamPreview/ExamPreviewQA.vue